import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { HeaderText } from "./HeaderText";
import { Button } from "./Button";
import { SelectOption } from "./SelectOption";
import { SubListEntry } from "../Data/ApiTypes";

export interface ChooseSubscriptionModalProps {
    show:          boolean;
    setShow:       ( b: boolean ) => void;
    subscriptions: SubListEntry[];
    onSubmit:      ( s: SubListEntry ) => void;
}

export function ChooseSubscriptionModal( { show, setShow, subscriptions, onSubmit }: ChooseSubscriptionModalProps ) {
    const [selectedId, setSelectedId] = useState<number | null>( null );
    const selected = subscriptions.find( s => s.subscriptionId === selectedId ) ?? null;

    useEffect(() => {
        if( !show )
            setSelectedId( null );
    }, [show]);

    function submit( s: SubListEntry ) {
        onSubmit( s );
        setShow( false );
    }

    return <Modal show={show} onHide={() => setShow( false )} centered>
        <Modal.Header closeButton>
            <HeaderText>Assign to a plan</HeaderText>
        </Modal.Header>
        <Modal.Body>
            {subscriptions.length === 0 ? (
                <div className="text-secondary small">
                    No plan is waiting for a plate. A plan shows up here when it doesn&apos;t have a vehicle yet.
                </div>
            ) : (
                <>
                    <div className="fw-semibold mb-2">Choose a plan</div>
                    <div className="d-flex flex-column gap-2">
                        {subscriptions.map( s =>
                            <SelectOption key={s.subscriptionId} selected={s.subscriptionId === selectedId} onClick={() => setSelectedId( s.subscriptionId )}>
                                <div className="min-w-0">
                                    <div className="fw-semibold">{s.plan.name}</div>
                                    <div className="text-secondary small">{s.facility.name}</div>
                                </div>
                            </SelectOption>
                        )}
                    </div>
                </>
            )}
            <Button type="button"
                    className="w-100 btn-main mt-3"
                    disabled={selected == null}
                    onClick={() => { if( selected ) submit( selected ); }}>
                {selected ? `Assign ${selected.plan.name}` : "Assign"}
            </Button>
            <button type="button"
                    className="btn btn-link w-100 mt-1 text-secondary text-decoration-none"
                    onClick={() => setShow( false )}>
                Cancel
            </button>
        </Modal.Body>
    </Modal>;
}
